import { 
    apiRequest,
    koreksiKehadiranCreate,
    koreksiKehadiranApproval,
    koreksiKehadiranDinas,
    getMinDate,
    getCorrectionTypes,
    checkDate,
} from '../../../../../../services/adapters/kepegawaian/koreksiKehadiranService'

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", koreksiKehadiranCreate, {
            body: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", koreksiKehadiranApproval, {
            body: query
        }, true)
    }
    
    fetchDinas = async (query, cancelToken) => {
        return await apiRequest("get", koreksiKehadiranDinas, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchMinDate = async (query) => {
        return await apiRequest("get", getMinDate, {
            params: query
        }, true)
    }

    fetchCheckDate = async (query) => {
        return await apiRequest("get", checkDate, {
            params: query
        }, true)
    }


    fetchCorrectionTypes = async (query) => {
        return await apiRequest("get", getCorrectionTypes, {
            params: query
        }, true)
    }

}

export default CreateRepository